import React, { useState } from 'react';
import { admissionDropdown } from "../Components/DropdownNavItems"
import { Link } from 'react-router-dom';
import "../index.css"

const AdmissionDropDown = () => {
    const [dropDown, setDropDown] = useState(false)
    return (
        <div>
            <>
                <ul className={dropDown ? "admission-submenu clicked" : "admission-submenu"} onClick={() => setDropDown(!dropDown)}>
                    {
                        admissionDropdown.map(item => {
                            return (
                                <li key={item.id}>
                                    <Link to={item.path} className={item.cName} onClick={() => setDropDown(false)}>{item.title}</Link>
                                </li>
                            )
                        })
                    }
                </ul>
            </>
        </div>
    );
}

export default AdmissionDropDown;
